import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import IntlMessages from 'util/IntlMessages';
import { useSelector } from 'react-redux';
const options = [
    {value: 'email',label:<IntlMessages id="pages.Mail"/>,},
    {value: 'mobile',label:<IntlMessages id="Mobile"/>,},
    {value: 'email_mobile',label:<IntlMessages id="Email.and.Mobile"/>,},
    {value: 'email_link',label:<IntlMessages id="email.link"/>,},
    {value: 'email_link_mobile',label:<IntlMessages id="email.and.mobile.link"/>,},
    {value: 'none',label:<IntlMessages id="None2"/>,},
];
const optionsGetAccept = [
    {
        value: 'email',
        label:<IntlMessages id="pages.Mail"/>,
    },
    {
        value: 'email_mobile',
        label:<IntlMessages id="Email.and.Mobile"/>,
    },
];
const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));

export default function InputComponent(props) {
    const classes = useStyles();
    const [Value, setValue] = React.useState(props.Value);
    const [Value2, setValue2] = React.useState(props.Value2);
const Flags = useSelector(state => state.accountsData.Flags);
    const handleChange = (event) => {
        setValue(event.target.value);
        props.onchangeHanelEvent("Bekraftelse",event.target.value)
    };
    React.useEffect(()=>{
        if(Value2 !== props.Value2){
            setValue(props.Value2)
            setValue2(props.Value2)
        }
    })
    return (
        <form className={classes.root}>
            <div>
                <TextField
                    select
                    label={<IntlMessages id="Confirmation"/>}
                    variant="outlined"
                    size="small"
                    value={Value}
                    fullWidth
                    onChange={handleChange}
                    SelectProps={{
                        native: true,
                    }}
                >
                    {
                    parseInt(Flags.GetAccept) === 1?
                    optionsGetAccept.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))
                    :
                    options.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </TextField>
            </div>
        </form>
    );
}